export const ADVERTISING_CONSENT_COOKIE = '_cmp_advertising';
export const ANALYTICS_CONSENT_COOKIE = '_cmp_analytics';
export const MARKETING_CONSENT_COOKIE = '_cmp_marketing';
export const PERSONALISATION_CONSENT_COOKIE = '_cmp_personalisation';

export const getCookie = (name: string): string | null => {
    if (typeof document === 'undefined') {
        return null;
    }

    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
        cookie = cookie.trim();
        if (cookie.startsWith(nameEQ)) {
            return decodeURIComponent(cookie.substring(nameEQ.length));
        }
    }

    return null;
};
